import { DeclaredAddress } from '@nemuru-eng/js-api-client';

import { AddressSchemaType } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/schemas/AddressSchema';

export const getFormattedAddress = (address: AddressSchemaType) => {
  return `${address.streetName}${address.streetNumber ? ` ${address.streetNumber}` : ''}, ${address.postalCode} ${
    address.city
  },${address.province ? ` ${address.province},` : ''} ${address.countryLongName}`;
};

export const getFormattedAddressFromDeclaredAddress = (declaredAddress: DeclaredAddress) => {
  return `${declaredAddress.streetAddress}${declaredAddress.number ? ` ${declaredAddress.number}` : ''}, ${
    declaredAddress.postalCode
  } ${declaredAddress.city}, ${declaredAddress.country}`;
};
